import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  input,
  output,
} from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'shared-modal-container',
  imports: [IconComponent, NgClass, ButtonDirective],
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideUpAndDown', [
      state('down', style({ height: 0 })),
      state('up', style({ minHeight: '100dvh', maxHeight: '100dvh' })),
      transition('* => *', animate('300ms ease-in-out')),
    ]),
  ],
})
export class ModalContainerComponent implements AfterViewInit {
  readonly headline = input.required<string>();
  readonly isDialogPositionUp = input<boolean>(false);
  readonly maxWidth = input<string>('30rem');
  readonly contentStyleClass = input<string | undefined>(undefined);
  readonly showCloseButton = input<boolean>(true);

  readonly closeModal = output();

  @ViewChild('body') bodyRef: ElementRef | undefined;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.bodyRef != null) {
        this.bodyRef.nativeElement.scrollTop = 0;
      }
    }, 100);
  }

  emitCloseForm(): void {
    this.closeModal.emit();
  }
}
